const { h, render , Component} = require('preact');
const {Router, route} = require('preact-router')
const queryString = require('qs')

const GrouponsLandingPageContainer = require('./components/containers/main/groupons_landing')
const ClaimsLandingPageContainer = require('./components/containers/gplus/claims_landing')
const ItemsListPageContainer = require('./components/containers/common/items')
const OrderSummaryPageContainer = require('./components/containers/order/summary')
const RefundRequestPageContainer = require('./components/containers/refund_form/refund_request_form')
const FAQSearchContainer = require('./components/containers/search/faq_search_bar')
const BreadCrumbMappings = require('./components/views/common/breadcrumbs/mappings')
const BreadCrumbsHelper = require('./components/views/common/breadcrumbs/helper')
const ThankYouPageContainer = require('./components/views/main/thank_you')
const FAQMain = require('./components/containers/all_faqs/faq_main')
const ErrorPageView = require('./components/containers/main/error')
const ClaimSummaryPageContainer = require('./components/containers/gplus/claim/summary')
const Header = require('../frontend/components/views/common/header')
const BreadCrumbs = require('./components/views/common/breadcrumbs/breadcrumbs')
const Helper = require('./helper')
const ContextualSearchPageContainer = require('./components/containers/search/contextual_search_results')
const FeedbackModal = require('./components/containers/customer_feedback/feedback_modal');
const GuestHelpContainer =  require('./components/containers/guest/main')

/*
 All the routes will go here with prefix /web/* except summary page
 Any route which needs breadcrumb text add it in /breadcrumbs/mappings.js
*/


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFeedbackModal: false,
      guestCheckoutHelp: {}
    }
    this.navigatingToUrl = null;
    this.openInNewTab = false;
    this.updateBreadCrumb = this.updateBreadCrumb.bind(this);
    this.handleRoute = this.handleRoute.bind(this);
    this.setCrumbElements = this.setCrumbElements.bind(this)
    this.getBreadCrumbText = this.getBreadCrumbText.bind(this)
    this.handleCrumbClick  = this.handleCrumbClick.bind(this)
    this.hideFeedbackModal = this.hideFeedbackModal.bind(this)
    this.handleGuestHelp = this.handleGuestHelp.bind(this);
    this.handleGuestHelpFromFAQ = this.handleGuestHelpFromFAQ.bind(this);
  }

  handleCrumbClick(crumb){
    this.updateBreadCrumb(crumb)
  }

  componentDidMount() {
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom.showCustomerFeedbackExperienceWeb) {
      document.getElementsByTagName('body')[0].addEventListener('click', (e) => {
        let clickedElementBubblePath = e.composedPath(), navigatingAway = false, time_diff = 0,
          lastTimeSubmit = window.localStorage.getItem('customer-support-feedback-submit-time'),
          survey_interval_in_milli_seconds = 1000 * 60 * 60 * configFromDom.survey_interval_in_hours;
        if(lastTimeSubmit == null)
          time_diff = 1
        else
          time_diff = (Date.now() - lastTimeSubmit) / survey_interval_in_milli_seconds;
        if(time_diff >= 1) {
          for(let elem of clickedElementBubblePath) {
            if(elem.href) {
              let clickedOnKnowUrl = configFromDom.blockUrlsForAskingFeedback.some((url) => {
                return new RegExp(url).test(elem.href) 
              })
              if(!clickedOnKnowUrl) {
                this.navigatingToUrl = elem.href;
                navigatingAway = !(this.openInNewTab = (elem.target == "_blank")); // do not show feedback pop up if link opens in new tab - TRA-16708
              }
              /* 
                Breaking here because browser will always redirect to the first
                anchor tag href in the path if there are multiples 
              */
              break;
            }
          }
          if(navigatingAway) {
            this.setState({showFeedbackModal: true})
            e.preventDefault();
            e.stopPropagation();
          }
        }
      })
    }
  }

  hideFeedbackModal() {
    this.setState({showFeedbackModal: false})
  }

  updateBreadCrumb(currentRoute) {
    if(BreadCrumbsHelper.noCrumbsRoute(currentRoute.url)) {
      this.setState({ crumbs: [ BreadCrumbsHelper.defaultCrumb() ] });
      return;
    }
    let newCrumbState = []
    let lastPushedCrumb = undefined
    for (var crumb in this.state.crumbs) {
      if (this.state.crumbs[crumb].url.split('?')[0] == currentRoute.url.split('?')[0]) {
        break
      }
      else {
        newCrumbState.push(this.state.crumbs[crumb])
        lastPushedCrumb = this.state.crumbs[crumb]
      }
    }
    if ((currentRoute.text && !lastPushedCrumb) || ((lastPushedCrumb && (currentRoute.text && lastPushedCrumb.text != currentRoute.text))))
      newCrumbState.push(currentRoute)
    this.setState({'crumbs': newCrumbState})
  }

  handleRoute(routeEvent) {
    OptimizeSuite.treatAsNewPage(window.location.href)
    if (routeEvent.current && routeEvent.current.attributes) {
      let currentRouteAttributes = routeEvent.current.attributes
      if('/customer_support/web/thank_you' === currentRouteAttributes.path) {
        this.setState( { guestCheckoutHelp: {} });
      }
      this.updateBreadCrumb({
        'text': BreadCrumbMappings[currentRouteAttributes.path],
        'url': currentRouteAttributes.url,
        'path': currentRouteAttributes.path
      })
    }
    let shouldHideFeedbackModal = ((routeEvent.URL !== routeEvent.previous) && this.state.showFeedbackModal)
    if (window.location.hash)
      this.setCrumbElements(routeEvent.current.attributes, shouldHideFeedbackModal)
   else
     if(shouldHideFeedbackModal) {
      this.setState({showFeedbackModal: false})
    }
  }

  getBreadCrumbText(hashFragment) {
    if (hashFragment.split('?')[0]) {
      for (var crumbMapping in BreadCrumbMappings) {
        if (hashFragment.split('?')[0].indexOf(crumbMapping) >= 0)
          return BreadCrumbMappings[crumbMapping]
      }
    }
    return null
  }

  setCrumbElements(currentRouteAttributes, shouldHideFeedbackModal) {
    let crumbElements = this.state.crumbs
    let hashFragment = currentRouteAttributes.url
    if (currentRouteAttributes.url.split('#')[1] != window.location.hash.split('#')[1])
      hashFragment = currentRouteAttributes.url.split('#')[0] + window.location.hash
    if (hashFragment && hashFragment.split('?')[1]) {
      crumbElements = JSON.parse(decodeURIComponent(escape(atob(queryString.parse(hashFragment.split('?')[1]).crumbs))))
      if (crumbElements[0].url == "/customer_support") {
        crumbElements[0].text = I18n.translate('js.modules.web_2018.customer_support_crumb')
      }
      if(shouldHideFeedbackModal)
        this.setState({'crumbs': crumbElements, showFeedbackModal: false})
      else
        this.setState({'crumbs': crumbElements})
      let mapping = this.getBreadCrumbText(hashFragment)
      if (mapping) {
        this.updateBreadCrumb({
          'text': mapping,
          'url': hashFragment,
          'path': hashFragment
        });
      }
    }
  }

  isLoggedIn() {
    let configFromDom = Groupon.Utils.getConfigFromDom();
    if (configFromDom && configFromDom.user) {
      return true;
    }
    return false;
  }

  handleGuestHelp(orderDetails) {
    if(this.isLoggedIn() || !Groupon.Utils.getConfigFromDom().guestCheckoutEnabledInWeb) return;
    if(this.state.guestCheckoutHelp.visitedFAQ) {
      this.setState({ guestCheckoutHelp: { ...this.state.guestCheckoutHelp, orderDetails }});
      let selectedInbentaResult = _.omit(this.state.guestCheckoutHelp.visitedFAQ, 'answer', 'bloodhoundTracking')
      let qs = Helper.getQueryStringForFAQToContactChannels(selectedInbentaResult)
      route(`/customer_support/web/contact_channels?${ qs }`);
    } else {
      this.setState({ guestCheckoutHelp: { ...this.state.guestCheckoutHelp, orderDetails }});
      route(`/faq#faqs:${Groupon.Utils.getConfigFromDom().guestCheckoutLandingFaqId}?crumbs=${BreadCrumbsHelper.articleCrumbQueryString()}`)
    }
  }

  handleGuestHelpFromFAQ(visitedFAQ) {
    if(this.isLoggedIn() || !Groupon.Utils.getConfigFromDom().guestCheckoutEnabledInWeb) return;
    this.setState({ guestCheckoutHelp: { ...this.state.guestCheckoutHelp, visitedFAQ }});
  }

  render() {
    let pageType, feedbackModalView = null;
    let queryParam = window.location.search.slice(1)
    let params = queryString.parse(queryParam);
    let LandingPage = GrouponsLandingPageContainer
    let URL = Helper.getActualURL(window.location.toString());
    //Use Case: This check is only for summary page having order id as query params
    if (this.isLoggedIn()) {
      if (params.id) {
        if (params.id == "undefined"){
          LandingPage = ErrorPageView
        }
        else{
          LandingPage = OrderSummaryPageContainer
          pageType = 'contextual'
        }
      }
    }
    if(this.state.showFeedbackModal) {
      let popups = document.getElementsByClassName('popup');
      Array.from(popups).forEach((popup) => {
        popup.parentNode.style.display = 'none';
      })
      feedbackModalView = <FeedbackModal 
        navigatingToUrl={this.navigatingToUrl} 
        hideFeedbackModal={this.hideFeedbackModal}
        openInNewTab={this.openInNewTab}
      />
    }
    return (
    <div>
      <BreadCrumbs crumbs={this.state.crumbs} handleCrumbClick={this.handleCrumbClick}/>
      <Header />
      { feedbackModalView }
      <Router url={URL} onChange={this.handleRoute}>
        <LandingPage
          order_id = {params.id}
          pageType = {pageType}
          path="/customer_support"
        />
        <FAQMain
          path="/faq" crumbs={this.state.crumbs}
          onGuestHelp={this.handleGuestHelpFromFAQ}
          showGuestHelp={!this.state.guestCheckoutHelp.orderDetails}
          guestOrder={this.state.guestCheckoutHelp.orderDetails}
        />
        <ItemsListPageContainer
          pageType="orders"
          path="/customer_support/web/orders"
        />
        <GuestHelpContainer
          path="/customer_support/web/guest"
          onGuestHelp={this.handleGuestHelp}
        />
        <OrderSummaryPageContainer
          pageType="contextual"
          path="/customer_support/web/order"
        />
        <OrderSummaryPageContainer
          pageType="contact_channels"
          path="/customer_support/web/contact_channels"
          guestOrder={this.state.guestCheckoutHelp.orderDetails}
        />
        <ContextualSearchPageContainer
          path="/customer_support/web/summary/search"
        />
        <ClaimsLandingPageContainer
          path="/customer_support/web/gplus"
        />
        <ItemsListPageContainer
          pageType="claims"
          path="/customer_support/web/claims"
        />
        <FAQSearchContainer
          path="/customer_support/web/faq/search"
          onGuestHelp={this.handleGuestHelpFromFAQ}
          showGuestHelp={!this.state.guestCheckoutHelp.orderDetails}
          guestOrder={this.state.guestCheckoutHelp.orderDetails}
        />
        <ThankYouPageContainer
          path="/customer_support/web/thank_you"
        />
        <ErrorPageView
          path="/customer_support/web/error"
        />
        <ClaimSummaryPageContainer
          pageType="contextual"
          path="/customer_support/web/claim/summary"
        />
        <ClaimSummaryPageContainer
            pageType="transactions"
            path="/customer_support/web/transactions"
        />
        <ClaimSummaryPageContainer
            pageType="contact_channels"
            showContactChannels="true"
            path="/customer_support/web/gplus/contact_channels"
        />
        <RefundRequestPageContainer
            pageType="refund_request"
            path="/customer_support/web/refund_request"
        />
      </Router>
    </div>
    )
  }
}
module.exports = App;
